import { Page, PageTable } from '@components-common/layouts';
import { layoutWorkspace } from '../_common/layout.workspace';
import { ConfigurationForm } from '../../components-domain/generation-domain/configurations/wizard/ConfigurationForm';
import { BuildingConfigInfoColumn } from './_customCollumns';
import { ReviewConfigPage } from '../../components-domain/generation-domain/configurations/ReviewConfigPage';

/**
 * Configuration Object: buildingConfigurationsScreens
 *
 * This object contains the configuration for the building configurations screens.
 * It includes roles, layout, protection status, and screen configurations.
 */
export const buildingConfigurationsScreens = {
  id: 'building_configurations',
  layout: layoutWorkspace,
  protected: false,
  screens: [
    {
      id: 'index',
      tmp: 'index',
      Component: PageTable,
      path: '.',
      columns: ['name', 'description', BuildingConfigInfoColumn, 'createdDate'],
      roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
      title: 'Building Configurations',
      source: '/buildingsconfigms/configurations/getSelf',
      actions: [
        {
          id: 'review',
          onClick: (props: any) => {
            props.navigate(`review/${props.row.id}`);
          },
          displayTooltip: true,
          tooltipText: 'Review configuration',
        },
        {
          id: 'delete',
          roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
          additionalChecks: ({ row }: any) => {
            return row.assignment === null;
          },
          actionToDispatch: {
            payload: {
              endpointToDelete: '/buildingsconfigms/configurations',
            },
          },
          displayTooltip: true,
          tooltipText: 'Delete configuration',
        },
      ],
    },
    {
      id: 'create',
      path: 'new',
      roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
      Component: Page,
      tmp: 'custom',
      children: [
        {
          Component: ConfigurationForm,
          type: 'create',
          cat: 'form',
        },
      ],
      endpoints: '/buildingsconfigms/configurations',
    },
    {
      id: 'review',
      path: 'review/:buildingConfigId',
      title: 'Review Configuration',
      roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
      Component: Page,
      tmp: 'custom',
      children: [
        {
          Component: ReviewConfigPage,
          cat: 'custom',
        },
      ],
    },
  ],
};
